import { createCustomAsyncThunk } from './helpers/createCustomAsyncThunk';
import { GrowlContextType } from '../../types/Growl';

type AuthArgs = {
  serverAuthCookie?: string;
  clientGrowl?: GrowlContextType;
  serverLogger?: any;
  clientTracker?: any;
};

export const setThunkExtras = createCustomAsyncThunk<void, AuthArgs>(
  'setThunkExtras',
  async (args: AuthArgs, thunkAPI) => {
    if (args.clientGrowl && thunkAPI.extra.clientGrowl) {
      thunkAPI.extra.clientGrowl.set(args.clientGrowl);
    }

    if (args.clientTracker && thunkAPI.extra.clientTracker) {
      thunkAPI.extra.clientTracker.set(args.clientTracker);
    }

    if (args.serverLogger && thunkAPI.extra.serverLogger) {
      thunkAPI.extra.serverLogger.set(args.serverLogger);
    }
  }
);
